/**
 * Utilities for normalizing cached TipTap HTML rendered outside a live editor.
 *
 * TipTap injects a `<br class="ProseMirror-trailingBreak">` inside empty `<p>`
 * elements, giving them non-zero height. Cached HTML (saved via `editor.getHTML()`)
 * lacks this — `<p></p>` collapses to 0px. These helpers fix that.
 */

const EMPTY_P_RE = /<p(\s[^>]*)?>\s*(<br\/?>)?\s*<\/p>/g

/**
 * Replace empty `<p>` tags with `<p>&nbsp;</p>` to prevent 0px height collapse
 * when rendering cached HTML outside TipTap.
 */
export function normalizeEmptyParagraphs(html: string): string {
  return html.replace(EMPTY_P_RE, (_, attrs) => `<p${attrs || ''}>\u00a0</p>`)
}

/**
 * Check if an HTML string represents an empty document (no visible content).
 * Returns true for empty strings, single empty paragraphs like `<p></p>`, etc.
 */
export function isEmptyDocHtml(html: string | null | undefined): boolean {
  if (!html) return true
  const stripped = html.replace(EMPTY_P_RE, "").trim()
  return stripped.length === 0
}
